import { visitorConstants } from "../../constants";
import { visitorServices } from "../../services";

const getOrCreateId = () => {
  const id = visitorServices.getOrCreateId();
  return dispatch => {
    dispatch({
      type: visitorConstants.GET_OR_CREATE_ID,
      payload: { id },
    })
  };
}

export const visitorActions = {
  getOrCreateId,
};